import easyfyAxios from '@shared/easyfy.axios';

namespace Easyfy.Web.Services.Filter {
  export interface IQuery {
    checkedFilters: IFilter[];
    sorter?: ISorter;
    page: number;
    applyFilterGroupCount?: IFacetGroupCount;
    searchString: string;
  }

  export interface IFacetGroupCount {
    key: string;
    valueCountData: IFacetValueCount[];
  }

  export interface IFacetValueCount {
    value: string;
    count: Number;
  }

  export interface IFilter {
    key: string;
    operator: FilterOperator;
    values: string[];
  } 

  export enum FilterOperator {
    Equal,
    NotEqual,
    GreaterThan,
    LessThan 
  }

  export interface ISorter {
    key: string;
    sortdirection: number;
  }

  export const GetProducts = async (pageId: string, data: IQuery, filterFor: string, productListName): Promise<any> => {
    productListName = encodeURIComponent(productListName);
    return await easyfyAxios.post(`/category?handler=ProductList&pageId=${pageId}&filterFor=${filterFor}&productListName=${productListName}`, data);
  };

  export const GetArticles = async (pageId: string, data: IQuery): Promise<any> => {
    return await easyfyAxios.post(`/articlelist?handler=ArticleList&pageId=${pageId}`, data);
  };
}

export default Easyfy.Web.Services.Filter;